/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id      : 'dashboards',
        title   : 'Dashboards',
        type    : 'group',
        icon    : 'heroicons_outline:home',
        children: [
            {
                id   : 'homepage',
                title: 'Overview',
                subtitle: 'Plant overview',
                type : 'basic',
                icon : 'heroicons_outline:home',
                link : '/overview',
                allowedRoles: ['System Admin', 'Admin', 'Viewer'],
            },
            {
                id   : 'dev',
                title: 'Dev',
                type : 'basic',
                icon : 'heroicons_outline:code-bracket',
                link : '/dev',
                allowedRoles: ['System Admin'],
            },
        ],
        allowedRoles: ['System Admin', 'Admin', 'Viewer'],
    },
    {
        id      : 'plant',
        title   : 'Plant management',
        // subtitle: 'Description here..',
        type    : 'group',
        icon    : 'heroicons_outline:home',
        children: [
            {
                id   : 'editor',
                title: 'Editor',
                subtitle: 'Plant editor',
                type : 'basic',
                icon : 'heroicons_outline:square-2-stack',
                link : '/editor',
                allowedRoles: ['System Admin', 'Admin'],
            },
            {
                id   : 'buildings',
                title: 'Buildings',
                subtitle: 'Manage buildings',
                type : 'basic',
                icon : 'heroicons_outline:building-office-2',
                link : '/buildings',
                allowedRoles: ['System Admin'],
            },
            {
                id   : 'areas',
                title: 'Areas',
                subtitle: 'Areas management',
                type : 'basic',
                icon : 'heroicons_outline:square-2-stack',
                link : '/areas',
                allowedRoles: ['System Admin', 'Admin'],
            },
            {
                id   : 'sensors',
                title: 'Sensors',
                subtitle: 'Sensors management',
                type : 'basic',
                icon : 'heroicons_outline:bolt',
                link : '/sensors',
                allowedRoles: ['System Admin'],
            },
        ],
        allowedRoles: ['System Admin', 'Admin'],
    },
    {
        id      : 'management',
        title   : 'Management',
        subtitle: 'Description here..',
        type    : 'group',
        icon    : 'heroicons_outline:home',
        children: [
            {
                id   : 'customers',
                title: 'Customers',
                subtitle: 'Customers management',
                type : 'basic',
                icon : 'heroicons_outline:cog-6-tooth',
                link : '/customers',
                allowedRoles: ['System Admin'],
            },
            {
                id   : 'users',
                title: 'Users',
                subtitle: 'Users management',
                type : 'basic',
                icon : 'heroicons_outline:user-group',
                link : '/users',
                allowedRoles: ['System Admin', 'Admin'],
            },
        ],
        allowedRoles: ['System Admin', 'Admin'],
    },
    // {
    //     id      : 'documentation',
    //     title   : 'Documentation',
    //     subtitle: 'Description here..',
    //     type    : 'group',
    //     icon    : 'heroicons_outline:book-open',
    //     children: [
    //         {
    //             id   : 'guides',
    //             title: 'Guides',
    //             subtitle: 'Software documentation',
    //             type : 'basic',
    //             icon : 'heroicons_outline:book-open',
    //             link : '/docs',
    //             badge: {
    //                 title  : 'TODO',
    //                 classes: 'px-2 bg-orange-600 text-white rounded-full',
    //             },
    //         },
    //     ]
    // }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
